import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, headers: { "Content-Type": "application/json" } });

export const customersApi = {
  list: () => api.get("/customers").then(r => r.data),
  create: (data) => api.post("/customers", data).then(r => r.data),
  get: (id) => api.get(`/customers/${id}`).then(r => r.data),
  update: (id, data) => api.put(`/customers/${id}`, data).then(r => r.data),
  remove: (id) => api.delete(`/customers/${id}`).then(r => r.data),
  uploadCsv: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/customers/upload-csv`, fd).then(r => r.data);
  },
};

export const invoicesApi = {
  list: (params = {}) => api.get("/invoices", { params }).then(r => r.data),
  create: (data) => api.post("/invoices", data).then(r => r.data),
  update: (id, data) => api.put(`/invoices/${id}`, data).then(r => r.data),
  remove: (id) => api.delete(`/invoices/${id}`).then(r => r.data),
};

export const aiApi = {
  generateScript: (data) => api.post("/ai/generate-script", data).then(r => r.data),
};

export const remindersApi = {
  send: (data) => api.post("/reminders/send", data).then(r => r.data),
  autoRun: () => api.post("/reminders/auto-run").then(r => r.data),
};

export const commsApi = {
  list: (params = {}) => api.get("/communications", { params }).then(r => r.data),
};

export const repliesApi = {
  simulate: (data) => api.post("/replies/simulate", data).then(r => r.data),
  stats: () => api.get("/replies/stats").then(r => r.data),
};

export const dashboardApi = {
  stats: () => api.get("/dashboard/stats").then(r => r.data),
};

export const settingsApi = {
  get: () => api.get("/settings").then(r => r.data),
};

export const seedApi = {
  demo: () => api.post("/seed-demo").then(r => r.data),
};
